import { render, staticRenderFns } from "./FadeOverlay.vue?vue&type=template&id=6bec213d"
import script from "./FadeOverlay.vue?vue&type=script&lang=js"
export * from "./FadeOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports